import { IButtonCodeChars, IButtonCodeInts, IPostMessageParams } from "../components/Screen/ScreenInteractions"
import { Button, IInternalMessage } from "../hooks/useActionButtons"

export const mapButtonToChar = (button: Button): IButtonCodeChars => {
    switch (button) {
        case 'up':
            return 'u'
        case 'left':
            return 'l'
        case 'right': 
            return 'r'
        case 'down':
            return 'd'
        case 'x':
            return 'x'
        case 'z':
            return 'z'
        case 'start':
            return 's'
        default:
            return 'x'
    }
}
export const mapButtonToInt = (button: Button): IButtonCodeInts => {
    switch (button) {
        case 'up':
            return 1;
        case 'right': 
            return 2;
        case 'down':
            return 3;
        case 'left':
            return 4;
        case 'x':
            return 5;
        case 'z':
            return 6;
        case 'start':
            return 0;
        default:
            return 5;
    }
}
export const mapEvent = (e: IInternalMessage): IPostMessageParams => {
    return {
        c: mapButtonToChar(e.button),
        i: mapButtonToInt(e.button),
        e: e.event 
    }
}
